<template>
    <div>

      <div v-for="(zone,zone_id) in sector_zones" class="">
        <label>{{zone.label}}</label>
        <div v-for="(group,indexG) in groups">
          <div class="form-control">
            <label>{{group.label[lang]}} </label>
          </div>

          <div class="row" v-for="(question,indexQ) in group.questions">
            <div class="col-7">
              {{question[lang]}}
            </div>
            <div class="col-5">
              <div class="form-check-inline" v-if="!only_read">
                <input class="form-check-input saveQuestion requiredQuestion"

                       type="radio"
                       @change="updateSatisfactionGroup($event, indexQ,indexG,zone_id)"
                       :name="'questions['+zone_id+']['+indexG+'][questions]['+indexQ+']'"
                       value="0"
                       v-model="answers[indexG]['questions'][zone_id][indexQ]"
                >
<!--                <span v-else-if="answers[indexG]['questions'][zone_id][indexQ] == 0">-->
<!--                    X-->
<!--                </span>-->
                <label class="form-check-label" >NV</label>
              </div>
              <div style="display: inline-block" v-else>
                  <span v-if="answers[indexG]['questions'][zone_id][indexQ] == 0" style="font-weight: 900;text-decoration: underline;" >
                    NV
                  </span>
                  <span v-else>NV</span>
              </div>

              <div class="form-check-inline" v-if="!only_read" v-for="number in max_evaluation_value">
                <input

                    class="form-check-input saveQuestion requiredQuestion"
                    type="radio"
                    @change="updateSatisfactionGroup($event, indexQ,indexG,zone_id)"
                    :name="'questions['+zone_id+']['+indexG+'][questions]['+indexQ+']'"
                    :value="number" v-model="answers [indexG]['questions'][zone_id][indexQ]"
                >
<!--                <span v-else-if="answers[indexG]['questions'][zone_id][indexQ] == number">-->
<!--                    X-->
<!--                </span>-->
<!--                <span v-else>-->

<!--                </span>-->
                <label style="display: inline-block" >{{number}} </label>
              </div>

              <div style="display: inline-block;margin-left: 20px" v-else>
                  <span v-if="answers[indexG]['questions'][zone_id][indexQ] == number" style="font-weight: 900;text-decoration: underline;" >
                    {{number}}
                  </span>
                  <span v-else>{{ number }}</span>
              </div>
            </div>

          </div>
          <div class="col-12 form-group" v-if="group.enable_comment">
            <label>{{group.comments[lang]}}</label>
            <textarea class="form-control"
                    v-if="!only_read"
                    v-model="answers [indexG]['comment']"
                    @change="updateSatisfactionCommentGroup($event,indexG,zone_id)"
            ></textarea>
            <div v-else>
              {{answers [indexG]['comment']}}
            </div>

          </div>
        </div>
      </div>


    </div>

</template>

<script>

export default {

    mounted() {
      //show row avg
      this.$root.$refs.satisfaction_summary['show_'+this.sector] = true;
      this.getAverageSector();
    },
    data () {
        return {

        }
    },
    methods: {

      getAverageSector(){

        axios.get("/satisfaction-surveys/courses/"+this.course_person+"/getAverageSector",
            {
              params : {
                "sector"        : this.sector
              }
            }
        )
        .then((response) => {
            this.$root.$refs.satisfaction_summary[this.sector] = response.data;
        });
      },

      updateSatisfactionGroup(event, indexQ,indexG,zone_id){
        Vue.$toast.open({
          message: 'Saving in progress, don\'t close the sheet...',
          type: 'warning',
          icon: 'warning',
          position: 'top-left'
        });
        //+this.userUrl
        axios.put("/satisfaction-surveys/"+this.course_person+"/updateNumericAnswers",
            {
              answer : {
                "userValue"     : event.target.value,
                "indexQuestion" : indexQ,
                "indexGroup"    : indexG,
                "zoneId"       : zone_id,
                "sector"        : this.sector

              }
            }
        )
            .then((response) => {
              Vue.$toast.open({
                message: 'Save Complete!',
                type: 'success',
                position: 'top-left'
              });
                this.getAverageSector();
            });
      },
      updateSatisfactionCommentGroup(event, indexG,zone_id){

        Vue.$toast.open({
          message: 'Saving in progress, don\'t close the sheet...',
          type: 'warning',
          icon: 'warning',
          position: 'top-left'
        });
        //+this.userUrl
        axios.put("/satisfaction-surveys/"+this.course_person+"/updateCommentAnswers",
            {
              answer : {
                "userValue"     : event.target.value,
                "indexGroup"    : indexG,
                "zoneId"       : zone_id,
                "sector"        : this.sector

              }
            }
        )
            .then((response) => {
              Vue.$toast.open({
                message: 'Save Complete!',
                type: 'success',
                position: 'top-left'
              });
            });
      },


    },
    props: {
        course_person: {
            type: Number,
            required: true
        },
        sector: {
            type: String,
            required: true
        },
        lang: {
            type: String,
            required: true
        },
        groups: {
            type: Object,
            required: true
        },
        max_evaluation_value : {
            type: Number,
            required : true,
        },
        answers : {
            type : Object ,
            required : true
        },

        sector_zones : {
            type : [Array,Object] ,
            required : true
        },

        only_read : {
            type: Boolean,
            required : true,
        },



    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
